/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createWebListingPayment} from '../api'

export const useMutationCreateWebListingPayment = createReactQueryMutationHook('createWebListingPayment', createWebListingPayment)
